import { TaxActionItemType } from "store/apis/actionItems";
import { BillingInvoice } from "types/Models/billing";
import { ChatTicket } from "types/Models/chatTicket";
import { Task } from "types/Models/task";
import {
  EQUAL,
  GREATER_THAN,
  GREATER_THAN_EQUAL,
  LESSER_THAN,
  LESSER_THAN_EQUAL,
} from "./task";

export const TODO_LIST_TYPE_TABS = {
  ALL: "ALL",
  OVERDUE: "OVERDUE",
  TODAY: "TODAY",
  THIS_WEEK: "THIS_WEEK",
} as const;

export type TodoListTab = keyof typeof TODO_LIST_TYPE_TABS;

export const TODO_LIST_TABS_DISPLAY = {
  [TODO_LIST_TYPE_TABS.ALL]: "All",
  [TODO_LIST_TYPE_TABS.OVERDUE]: "Overdue",
  [TODO_LIST_TYPE_TABS.TODAY]: "Today",
  [TODO_LIST_TYPE_TABS.THIS_WEEK]: "This week",
};

export const AGENT_UPDATE_ITEM = "UPDATE";
export const AGENT_ACT_ITEM = "ACT";
export const AGENT_CHASE_ITEM = "CHASE";

export type AgentItemType =
  | typeof AGENT_UPDATE_ITEM
  | typeof AGENT_ACT_ITEM
  | typeof AGENT_CHASE_ITEM;

// Task-related metrics
export const AGENT_TASK_ETD_DUE = "TASK_ETD_DUE";
export const AGENT_TASK_ETD_ASSIGN = "TASK_ETD_ASSIGN";
export const AGENT_PREPARER_TEAM_ASSIGN = "PREPARER_TEAM_ASSIGN";
export const AGENT_PREPARER_ASSIGN = "PREPARER_ASSIGN";

// Ticket-related metrics
export const AGENT_TICKETS_ETD_DUE = "TICKETS_ETD_DUE";
export const AGENT_TICKETS_ETD_ASSIGN = "TICKETS_ETD_ASSIGN";

// Financial metrics
export const AGENT_UNPAID_INVOICE_DUE = "UNPAID_INVOICE_DUE";
export const AGENT_SUBSCRIPTION_FAILURE_DUE = "SUBSCRIPTION_FAILURE_DUE";

// Action items
export const AGENT_ACTION_ITEM = "ACTION_ITEM";

// Chat message action items (stale pending cards found via stream channel scan)
export const AGENT_CHAT_MESSAGE_ACTION_ITEM = "CHAT_MESSAGE_ACTION_ITEM";

// Chaser-specific metrics
export const AGENT_PENDING_MANDATORY_INVOICE = "PENDING_MANDATORY_INVOICE";
export const AGENT_FILING_CHAT_CARD_PENDING = "FILING_CHAT_CARD_PENDING";
export const AGENT_CLIENT_DOCUMENT_PENDING = "CLIENT_DOCUMENT_PENDING";
export const AGENT_REVIEW_DRAFT_PENDING = "REVIEW_DRAFT_PENDING";
export const AGENT_CHAT_ACTION_ITEM_PENDING = "CHAT_ACTION_ITEM_PENDING";
export const AGENT_DOCUMENT_UPLOADED_PENDING_REVIEW =
  "DOCUMENT_UPLOADED_PENDING_REVIEW";
export const AGENT_CART_ITEM_PENDING = "CART_ITEM_PENDING";
export const AGENT_ANSWER_REQUEST_PENDING = "ANSWER_REQUEST_PENDING";
export const AGENT_INFO_REQUEST_PENDING = "INFO_REQUEST_PENDING";
export const AGENT_TASK_UPLOAD_PENDING = "TASK_UPLOAD_PENDING";
export const AGENT_FINANCIAL_REVIEW_REQUEST_PENDING =
  "FINANCIAL_REVIEW_REQUEST_PENDING";
export const AGENT_MEETING_REQUEST_PENDING = "MEETING_REQUEST_PENDING";

export const UNREPLIED = "UNREPLIED";
export const UNREAD = "UNREAD";

export const EtdStatus = {
  THIS_WEEK: "THIS_WEEK",
  TODAY: "TODAY",
  OVERDUE: "OVERDUE",
} as const;

export const FILING_OVERVIEW_TABS = {
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

export const FILING_OVERVIEW_TABS_DISPLAY = {
  [FILING_OVERVIEW_TABS.ALL]: "All",
  [FILING_OVERVIEW_TABS.ACTIVE]: "Active",
  [FILING_OVERVIEW_TABS.INACTIVE]: "Inactive",
};

export type FilingListTab = keyof typeof TODO_LIST_TYPE_TABS;

export const AGENT_DASHBOARD_FILING_NAME = "FILING_NAME";
export const AGENT_DASHBOARD_FILING_TAG = "FILING_TAG";
export const AGENT_DASHBOARD_ENTITY_NAME = "ENTITY";

export const FOREIGN_SUBSIDIARY_OPERATOR_DISPLAY = {
  [EQUAL]: "=",
  [GREATER_THAN]: ">",
  [LESSER_THAN]: "<",
  [GREATER_THAN_EQUAL]: ">=",
  [LESSER_THAN_EQUAL]: "<=",
};

export const TASK_TRACKER_BOOKKEEPING_STATUS_DISPLAY = {
  COMPLETED: "Completed",
  IN_PROGRESS: "In Progress",
  NOT_STARTED: "Not Started",
};
